export default "__VITE_ASSET__c86fe0c1__"